module.exports = __webpack_public_path__ + "img/logo-mini.9af6752b.png";